'use client';

import { UserVenueInfo } from '../hooks/useUserVenues';

interface NavigationInfo {
    text: string;
    href: string;
}

export function getNavigationInfo(
    user: any,
    loading: boolean,
    singleVenue: UserVenueInfo | null,
    venuesLoading: boolean
): NavigationInfo {
    // Show "Log in" if user is not authenticated
    if (!user && !loading) {
        return {
            text: 'Log in',
            href: '/login'
        };
    }

    // Show loading state or default to Profile while loading
    if (loading || venuesLoading) {
        return {
            text: 'Profile',
            href: '/profile'
        };
    }

    // If user is authenticated and manages exactly one venue
    if (user && singleVenue) {
        return {
            text: `Manage ${singleVenue.name}`,
            href: '/venue_admin?id=' + singleVenue.id
        };
    }

    // If user is authenticated but doesn't manage exactly one venue
    if (user) {
        return {
            text: 'Profile',
            href: '/profile'
        };
    }

    // Fallback
    return {
        text: 'Log in',
        href: '/login'
    };
} 